
import * as moment from 'moment';
import { FrequencyRepeatTypes, FrequencyEndType } from './models/invoice.model';

class RecurringFrequency {
  id: number;
  recurringInvoiceId: number;
  frequencyType: FrequencyRepeatTypes = FrequencyRepeatTypes.Monthly;
  endType: FrequencyEndType = FrequencyEndType.Never;
  count: number = 0;
  until: Date = null;
  interval: number = 1;
  byDay: string= null;
  byDayArray: any[];
  byMonth: number = 0;
  byMonthDay: number = 0;
  bySetPos: number = 1;
  dayType: string = 'day';
}

export function getFrequencyText(frequencyData): string {
  let recurringTextPieces: string[] = [];
  let daysOfTheWeek: string[] = [];
  daysOfTheWeek['SU'] = 'Sunday'
  daysOfTheWeek['MO'] = 'Monday'
  daysOfTheWeek['TU'] = 'Tuesday'
  daysOfTheWeek['WE'] = 'Wednesday'
  daysOfTheWeek['TH'] = 'Thursday'
  daysOfTheWeek['FR'] = 'Friday'
  daysOfTheWeek['SA'] = 'Saturday'

  const months: string[] = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const position: string[] = ['', 'First', 'Second', 'Third', 'Fourth', 'Last'];

  switch (frequencyData.frequencyType) {
    case FrequencyRepeatTypes.Daily:
      if (frequencyData.interval > 1) {
        recurringTextPieces.push(`Every ${frequencyData.interval} days`);
      } else {
        recurringTextPieces.push('Daily');
      }
      break;
    case FrequencyRepeatTypes.Weekly:
      let selectedDays: string[] = [];
      if (frequencyData.interval > 1) {
        recurringTextPieces.push(`Every ${frequencyData.interval} weeks on`);
      } else {
        recurringTextPieces.push('Weekly on');
      }

      Object.keys(daysOfTheWeek).map((index) => {
        if (frequencyData.byDay.split(',').indexOf(index) !== -1) {
          selectedDays.push(daysOfTheWeek[index]);
        }
      });

      recurringTextPieces.push(selectedDays.join(', '));

      break;
    case FrequencyRepeatTypes.Monthly:
      if (frequencyData.interval > 1) {
        recurringTextPieces.push(`Every ${frequencyData.interval} months,`);
      } else {
        recurringTextPieces.push('Monthly,');
      }

      if (frequencyData.byMonthDay) {
        recurringTextPieces.push(`on day ${frequencyData.byMonthDay}`);
      } else {
        recurringTextPieces.push(`on ${position[frequencyData.bySetPos]} ${daysOfTheWeek[frequencyData.byDay]}`);
      }
      break;
    case FrequencyRepeatTypes.Yearly:
      if (frequencyData.interval > 1) {
        recurringTextPieces.push(`Every ${frequencyData.interval} years,`);
      } else {
        recurringTextPieces.push('Yearly,');
      }

      if (frequencyData.byMonthDay) {
        recurringTextPieces.push(`on day ${frequencyData.byMonthDay}`);
      } else {
        recurringTextPieces.push(`on ${position[frequencyData.bySetPos]} ${daysOfTheWeek[frequencyData.byDay]}`);
      }

      recurringTextPieces.push(`of ${months[frequencyData.byMonth]}`);
      break;
  }

  return recurringTextPieces.join(' ');
}

export function getEndText(frequencyData): string {
  let endDateString: string = "Never";

  if (frequencyData.count) {
    endDateString = `Count ${frequencyData.count}`;
  } else if (frequencyData.until) {
    endDateString = `Until  ${moment(frequencyData.until).format('MM/DD/YYYY')}`;
  }

  return endDateString;
}

export function mapFrequencyRule(frequency: any): any {
  let recurringFrequency: RecurringFrequency = new RecurringFrequency();
  const frequencyData = frequency.split(';');

  frequencyData.forEach(data => {
    if (data) {
      const item = data.split('=');
      item[0] = item[0].toLowerCase();

      switch(item[0]) {
        case 'freq':
          item[0] = 'frequencyType';
          item[1] = FrequencyRepeatTypes[item[1].charAt(0) + item[1].slice(1).toLowerCase()];
          item[1] = parseInt(item[1]);
          break;
        case 'bymonth':
          item[0] = 'byMonth';
          item[1] = parseInt(item[1]);
            break;
        case 'bymonthday':
          item[0] = 'byMonthDay';
          item[1] = parseInt(item[1]);
          break;
        case 'bysetpos':
          item[0] = 'bySetPos';
          item[1] = parseInt(item[1]);
          break;
        case 'byday':
          item[0] = 'byDay';
          break;
      }

      recurringFrequency[item[0]] = item[1];
    }
  });

  return recurringFrequency;
}
